import React, { useState } from 'react';
import { Box, IconButton, Tooltip, Snackbar, SvgIcon } from '@mui/material';
import {
  Twitter as TwitterIcon,
  Facebook as FacebookIcon,
  WhatsApp as WhatsAppIcon,
  Instagram as InstagramIcon,
} from '@mui/icons-material';

// Ni Instagram ni Snapchat ne proposent d'API web pour pré-remplir un partage :
// on copie le texte dans le presse-papiers et on ouvre le réseau pour que
// l'utilisateur colle lui-même dans sa story/publication.
function SnapchatIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path d="M12 2c3.2 0 5.4 2.4 5.4 5.8 0 1.4-.1 2.5-.1 3.3.4.2 1 .2 1.4-.1.3-.2.7-.1.8.2.1.3 0 .7-.4.9-.5.3-1.1.5-1.6.7.1.5.4.9 1 1.3.5.3 1.1.5 1.7.6.3 0 .5.3.4.6-.1.5-.7.9-1.6 1.1-.2.1-.4.2-.4.4 0 .2 0 .5-.1.7-.1.2-.4.3-.7.2-.5-.1-1-.1-1.6.1-.6.2-1.1.6-1.8 1.1-.8.6-1.7 1.2-3 1.2s-2.2-.6-3-1.2c-.6-.5-1.2-.9-1.8-1.1-.6-.2-1.1-.2-1.6-.1-.3.1-.6 0-.7-.2-.1-.2-.1-.5-.1-.7 0-.2-.2-.3-.4-.4-.9-.2-1.5-.6-1.6-1.1-.1-.3.1-.6.4-.6.6-.1 1.2-.3 1.7-.6.6-.4.9-.8 1-1.3-.5-.2-1.1-.4-1.6-.7-.4-.2-.5-.6-.4-.9.1-.3.5-.4.8-.2.4.3 1 .3 1.4.1 0-.8-.1-1.9-.1-3.3C6.6 4.4 8.8 2 12 2z" />
    </SvgIcon>
  );
}

function ShareButtons({ text, url }) {
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');

  const openWindow = (href) => window.open(href, '_blank', 'noopener,noreferrer');

  const shareTwitter = () => {
    openWindow(`https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`);
  };

  const shareFacebook = () => {
    openWindow(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}&quote=${encodeURIComponent(text)}`);
  };

  const shareWhatsApp = () => {
    openWindow(`https://wa.me/?text=${encodeURIComponent(`${text} ${url}`)}`);
  };

  const shareViaCopy = async (network, homepage) => {
    try {
      await navigator.clipboard.writeText(`${text} ${url}`);
      setSnackbarMessage(`Lien copié ! Collez-le dans votre story ou publication ${network}.`);
    } catch {
      setSnackbarMessage(`Impossible de copier le lien automatiquement — copiez-le manuellement pour le partager sur ${network}.`);
    }
    setSnackbarOpen(true);
    openWindow(homepage);
  };

  return (
    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
      <Tooltip title="Partager sur X">
        <IconButton onClick={shareTwitter} sx={{ bgcolor: 'grey.100' }}>
          <TwitterIcon sx={{ color: '#000' }} />
        </IconButton>
      </Tooltip>
      <Tooltip title="Partager sur Facebook">
        <IconButton onClick={shareFacebook} sx={{ bgcolor: 'grey.100' }}>
          <FacebookIcon sx={{ color: '#1877F2' }} />
        </IconButton>
      </Tooltip>
      <Tooltip title="Partager sur WhatsApp">
        <IconButton onClick={shareWhatsApp} sx={{ bgcolor: 'grey.100' }}>
          <WhatsAppIcon sx={{ color: '#25D366' }} />
        </IconButton>
      </Tooltip>
      <Tooltip title="Copier le lien pour Instagram">
        <IconButton onClick={() => shareViaCopy('Instagram', 'https://www.instagram.com/')} sx={{ bgcolor: 'grey.100' }}>
          <InstagramIcon sx={{ color: '#E4405F' }} />
        </IconButton>
      </Tooltip>
      <Tooltip title="Copier le lien pour Snapchat">
        <IconButton onClick={() => shareViaCopy('Snapchat', 'https://www.snapchat.com/')} sx={{ bgcolor: 'grey.100' }}>
          <SnapchatIcon sx={{ color: '#FFFC00', stroke: '#000', strokeWidth: 0.3 }} />
        </IconButton>
      </Tooltip>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
      />
    </Box>
  );
}

export default ShareButtons;
